(function() {
  'use strict';

  var ROOT_SELECTOR = '[data-quiet-surfaces-page]';
  var BRIDGE_STORAGE_KEY = 'artmere_search_v2_selection_v1';
  var TRANSPORT_MAX_WAIT_MS = 15000;
  var TRANSPORT_SETTLE_MS = 400;

  function bounded(value, limit) {
    return String(value == null ? '' : value).slice(0, limit || 120);
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'artmere-quiet-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function publish(name, extra, discriminator) {
    if (typeof window.artmerePublishMeasurementEvent !== 'function') return false;
    return window.artmerePublishMeasurementEvent(name, extra || {}, discriminator || eventId());
  }

  function whenMeasurementTransportReady(callback) {
    var fired = false;
    var started = Date.now();

    function run() {
      if (fired) return;
      fired = true;
      callback();
    }

    function attempt() {
      if (fired) return;
      if (typeof window.gtag === 'function' && typeof window.artmerePublishMeasurementEvent === 'function') {
        setTimeout(run, TRANSPORT_SETTLE_MS);
        return;
      }
      if (Date.now() - started >= TRANSPORT_MAX_WAIT_MS) {
        run();
        return;
      }
      setTimeout(attempt, 200);
    }

    if (document.readyState === 'complete') {
      attempt();
    } else {
      window.addEventListener('load', attempt, { once: true });
      setTimeout(attempt, TRANSPORT_MAX_WAIT_MS);
    }
  }

  function itemFromLink(link, fallbackIndex) {
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var item = {
      item_id: bounded(link.getAttribute('data-item-id'), 80),
      item_variant: bounded(link.getAttribute('data-item-variant-id'), 80),
      item_name: bounded(link.getAttribute('data-item-name'), 160),
      item_list_id: 'quiet_surfaces',
      item_list_name: 'Quiet Surfaces',
      index: Number(link.getAttribute('data-item-index') || fallbackIndex || 1),
      price: Number(link.getAttribute('data-item-price') || 0),
      currency: bounded(link.getAttribute('data-item-currency') || 'USD', 12),
      destination_path: bounded(href, 240)
    };
    if (!item.item_id || !item.item_name || !href) return null;
    return item;
  }

  function storeSelection(selection) {
    try {
      sessionStorage.setItem(BRIDGE_STORAGE_KEY, JSON.stringify(selection));
    } catch (error) {}
  }

  function setPreviewMetadata() {
    document.title = document.documentElement.lang.toLowerCase().startsWith('de') ? 'Ruhige Oberflächen | Warm-minimalistische Gemälde | ARTMERE' : 'Quiet Surfaces | Warm Minimalist Paintings | ARTMERE';

    var robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', 'noindex, follow');

    var description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.setAttribute('name', 'description');
      document.head.appendChild(description);
    }
    description.setAttribute('content', 'A curated edit of warm minimalist and organic modern paintings, individually hand-painted on canvas.');
  }

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root || window.__artmereQuietSurfacesMeasurementInitialized) return;
    window.__artmereQuietSurfacesMeasurementInitialized = true;
    root.setAttribute('data-quiet-surfaces-tracking', 'ready');
    setPreviewMetadata();

    var gridLinks = Array.prototype.slice.call(root.querySelectorAll('[data-quiet-grid-item]'));
    var items = gridLinks.map(function(link, index) {
      return itemFromLink(link, index + 1);
    }).filter(Boolean);

    if (items.length) {
      whenMeasurementTransportReady(function() {
        publish('view_item_list', {
          surface: 'quiet_surfaces',
          item_list_id: 'quiet_surfaces',
          item_list_name: 'Quiet Surfaces',
          item_count: items.length,
          ecommerce: {
            item_list_id: 'quiet_surfaces',
            item_list_name: 'Quiet Surfaces',
            items: items
          }
        }, eventId());
      });
    }

    root.addEventListener('click', function(event) {
      if (event.__artmereQuietSurfacesHandled) return;
      var link = event.target && event.target.closest ? event.target.closest('[data-quiet-product-click]') : null;
      if (!link || !root.contains(link)) return;
      event.__artmereQuietSurfacesHandled = true;

      var item = itemFromLink(link, 1);
      if (!item) return;
      var selectedAt = new Date().toISOString();
      storeSelection({ selected_at: selectedAt, item: item });
      publish('select_item', {
        surface: 'quiet_surfaces',
        item_list_id: item.item_list_id,
        item_list_name: item.item_list_name,
        selected_item_id: item.item_id,
        selected_item_name: item.item_name,
        selected_item_index: item.index,
        destination_path: item.destination_path,
        ecommerce: {
          item_list_id: item.item_list_id,
          item_list_name: item.item_list_name,
          items: [item]
        }
      }, selectedAt + ':' + item.item_id);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
